var render = function render(){var _vm=this,_c=_vm._self._c;return _c('invite',{ref:"invite",on:{"inviteSent":_vm.inviteSent}})
}
var staticRenderFns = []

export { render, staticRenderFns }